import React, { PureComponent } from "react";
import d3 from "d3";

class PerceptualMapChart extends PureComponent {
  componentDidMount() {
    const data = [[0, 0, 15]];

    const margin = {
      top: 20,
      right: 15,
      bottom: 15,
      left: 15
    };

    const width = 400 - margin.left - margin.right;
    const height = 400 - margin.top - margin.bottom;

    // create the svg container
    const svg = d3
      .select("#PerceptualMapChart")
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    // set up the x scale
    const xScale = d3.scale
      .linear()
      .domain([-10, 10])
      .range([0, width]);

    // set up the y scale
    const yScale = d3.scale
      .linear()
      .domain([-10, 10])
      .range([height, 0]);

    const rScale = d3.scale
      .linear()
      .domain([0, 100])
      .range([0, height]);

    // append a circle
    svg
      .selectAll("circle")
      .data(data)
      .enter()
      .append("circle")
      .attr("cx", function(d) {
        return xScale(d[0]);
      })
      .attr("cy", function(d) {
        return yScale(d[1]);
      })
      .attr("r", function(d) {
        return rScale(d[2]);
      })
      .attr("class", "color-data");

    // define the x axis
    const xAxis = d3.svg
      .axis()
      .scale(xScale)
      .orient("bottom");

    // define the y axis
    const yAxis = d3.svg
      .axis()
      .scale(yScale)
      .orient("right");

    // call the xAxis function to generate the x axis
    svg
      .append("g")
      .attr("class", "axis")
      .attr("transform", "translate(0, " + height / 2 + ")")
      .call(xAxis);

    // call the yAxis function to generate the x axis
    svg
      .append("g")
      .attr("class", "axis")
      .attr("transform", "translate(" + width / 2 + ", 0)")
      .call(yAxis);

    // y NORTH
    svg
      .append("text")
      .attr("font-size", "10px")
      .attr("transform", "translate(" + width / 2 + " ," + -7 + ")")
      .style("text-anchor", "middle")
      .text("Sensitivity");

    // -y SOUTH
    svg
      .append("text")
      .attr("font-size", "10px")
      .attr(
        "transform",
        "translate(" + width / 2 + " ," + (height + margin.bottom - 2) + ")"
      )
      .style("text-anchor", "middle")
      .text("Resolution");

    // x EAST
    svg
      .append("text")
      .attr("font-size", "10px")
      .attr(
        "transform",
        "translate(" + (width - 25) + " ," + (height / 2 + 20) + ")"
      )
      .style("text-anchor", "middle")
      .text("Temp Range");

    // -x WEST
    svg
      .append("text")
      .attr("font-size", "10px")
      .attr("transform", "translate(" + 15 + " , " + (height / 2 + 20) + ")")
      .style("text-anchor", "middle")
      .text("Power");
  }

  render() {
    return (
      <div className="perceptualChart text-center">
        <div id="PerceptualMapChart"></div>
      </div>
    );
  }
}

export default PerceptualMapChart;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/charts/perceptual-map.js